import React, { useState } from "react";
import { Container, Row, Col, Card, Alert } from "react-bootstrap";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import AppConstants from "../../AppConstants";
import { AddPaymentMethodForm } from "./AddPaymentMethodForm";
import IconHeader from "../../images/logo.png";
import "./stripeStyles.scss";
import { IoWarningOutline } from "react-icons/io5";
import useAuthToken from "../../hooks/useAuthToken";

const stripePromise = loadStripe(AppConstants.STRIPE_PUBLISHABLE_KEY || "");

export default function AddPaymentMethodPage() {
  const { userToken, ready } = useAuthToken();
  const [tokenExpired, setTokenExpired] = useState(false);

  return (
    <section className="dashboard payment-method-page">
      <Container fluid>
        <Row className="justify-content-md-center">
          <Col xl={8} lg={10} sm={12}>
            <figure className="text-center mb-4">
              <img src={IconHeader} alt="logo" width={250} />
            </figure>
            <Card className="shadow-sm" style={{ borderRadius: 16 }}>
              <Card.Body className="px-4 pb-4">
                {!ready ? (
                  <div className="text-center">
                    <p>Initializing…</p>
                  </div>
                ) : !userToken ? (
                  <Alert variant="danger" className="text-center">
                    <IoWarningOutline />
                    <br /> Missing token. Please open via the app.
                  </Alert>
                ) : tokenExpired ? (
                  <div className="text-center py-5">
                    <Alert variant="danger">
                      <h5>Token Expired</h5>
                      <p className="mb-0">
                        Your session has been expired/invalid. Please return to
                        the mobile app and try again.
                      </p>
                    </Alert>
                  </div>
                ) : (
                  <Elements stripe={stripePromise}>
                    <AddPaymentMethodForm
                      inline={false}
                      compact={false}
                      enableSelection
                      allowMakePrimary
                      listStyle="list"
                      onTokenExpired={() => setTokenExpired(true)}
                    />
                  </Elements>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
